(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.renimsProductCardOptionsReady) return;
    window.renimsProductCardOptionsReady = true;

    const formatMoney = (cents, format) => {
      const amount = new Intl.NumberFormat(document.documentElement.lang || 'en', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(Number(cents || 0) / 100);

      if (format && format.includes('Rs')) return `Rs. ${amount}`;
      return amount;
    };

    const selectedOptions = (dialog) => {
      return [1, 2, 3].map((position) => {
        return dialog.querySelector(`[name="option${position}"]:checked`)?.value;
      }).filter(Boolean);
    };

    const findVariant = (dialog) => {
      const variants = JSON.parse(dialog.dataset.productJson || '[]');
      const options = selectedOptions(dialog);

      return variants.find((variant) => {
        return variant.options.every((option, index) => option === options[index]);
      });
    };

    const updateAvailability = (dialog) => {
      const variants = JSON.parse(dialog.dataset.productJson || '[]');
      const selectedPreviousOptions = [];

      [1, 2, 3].forEach((position) => {
        const inputs = [...dialog.querySelectorAll(`[name="option${position}"]`)];
        if (!inputs.length) return;

        inputs.forEach((input) => {
          const isAvailable = variants.some((variant) => {
            if (!variant.available || variant.options[position - 1] !== input.value) return false;
            return selectedPreviousOptions.every((value, index) => variant.options[index] === value);
          });

          input.disabled = !isAvailable;
        });

        let selectedInput = inputs.find((input) => input.checked && !input.disabled);
        if (!selectedInput) {
          selectedInput = inputs.find((input) => !input.disabled);
          if (selectedInput) selectedInput.checked = true;
        }

        if (selectedInput) selectedPreviousOptions.push(selectedInput.value);
      });
    };

    const updateDialog = (dialog) => {
      updateAvailability(dialog);
      const variant = findVariant(dialog);
      if (!variant) return;

      const variantInput = dialog.querySelector('[data-product-card-variant-id]');
      const price = dialog.querySelector('[data-product-card-options-price]');
      const compare = dialog.querySelector('[data-product-card-options-compare]');
      const addButton = dialog.querySelector('[data-product-card-add-to-cart]');
      const buyButton = dialog.querySelector('[data-product-card-buy-now]');
      const available = Boolean(variant.available);

      if (variantInput) variantInput.value = variant.id;
      if (price) price.textContent = formatMoney(variant.price, dialog.dataset.moneyFormat);
      if (compare) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compare.hidden = false;
          compare.textContent = formatMoney(variant.compare_at_price, dialog.dataset.moneyFormat);
        } else {
          compare.hidden = true;
          compare.textContent = '';
        }
      }

      if (addButton) {
        addButton.disabled = !available;
        addButton.textContent = available ? dialog.dataset.labelAddToCart : dialog.dataset.labelSoldOut;
      }
      if (buyButton) buyButton.disabled = !available;
    };

    const scrollMedia = (dialog, direction) => {
      const media = dialog.querySelector('[data-product-card-media]');
      if (!media) return;
      media.scrollBy({
        left: direction * media.clientWidth,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    };

    document.addEventListener('click', (event) => {
      const openButton = event.target.closest('[data-product-card-options-open]');
      if (openButton) {
        const article = openButton.closest('.product-card');
        const dialog = article?.querySelector('[data-product-card-options]');
        if (dialog) {
          if (typeof dialog.showModal === 'function') {
            dialog.showModal();
          } else {
            dialog.setAttribute('open', '');
          }
          updateDialog(dialog);
        }
        return;
      }

      const closeButton = event.target.closest('[data-product-card-options-close]');
      if (closeButton) {
        const dialog = closeButton.closest('[data-product-card-options]');
        if (dialog) dialog.close();
        return;
      }

      const previous = event.target.closest('[data-product-card-media-previous]');
      if (previous) {
        scrollMedia(previous.closest('[data-product-card-options]'), -1);
        return;
      }

      const next = event.target.closest('[data-product-card-media-next]');
      if (next) {
        scrollMedia(next.closest('[data-product-card-options]'), 1);
        return;
      }

      const minus = event.target.closest('[data-product-card-quantity-minus]');
      const plus = event.target.closest('[data-product-card-quantity-plus]');
      if (minus || plus) {
        const dialog = event.target.closest('[data-product-card-options]');
        const input = dialog?.querySelector('[data-product-card-quantity-input]');
        if (!input) return;
        const nextValue = Number(input.value || 1) + (plus ? 1 : -1);
        input.value = Math.max(1, nextValue);
      }
    });

    document.addEventListener('change', (event) => {
      if (!event.target.matches('[data-product-card-option-input]')) return;
      const dialog = event.target.closest('[data-product-card-options]');
      if (dialog) updateDialog(dialog);
    });

    document.addEventListener('click', (event) => {
      const dialog = event.target.closest('dialog[data-product-card-options]');
      if (dialog && event.target === dialog) dialog.close();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
